// extracted by extract-css-chunks-webpack-plugin
module.exports = {"children":"children___rJfxb","collapse":"collapse___AVHaM"};